import React, {useRef, useEffect} from 'react'
import Chart from "chart.js";
import {palette} from "./chartUtils";


const PieChart = ({data, xAxis, yAxis}) => {
    const pieRef = useRef()

    useEffect(() => {
        const chart = new Chart(pieRef.current, {
            type: 'pie',
            responsive: true,
            options: {
              tooltips: {
                  callbacks: {
                      label: (tooltip, data) => {
                          const currentDataIndex = tooltip.index
                          const {datasets} = data
                          const text = Number(datasets[0].data[currentDataIndex])
                          return text.toLocaleString()
                      }
                  }
              }
            },
            data: {
                labels: xAxis,
                datasets: [
                    {
                        data: yAxis,
                        borderColor: 'rgba(9,84,200,0.78)',
                        borderWidth: 2,
                        fill: false,
                        backgroundColor: palette
                    }
                ]
            }
        })

        return () => chart.destroy()
    }, [data, xAxis, yAxis])

    return (
        <React.Fragment>
            <div>
                <canvas ref={pieRef} />
            </div>
        </React.Fragment>
    )
}
export default PieChart